export default __webpack_public_path__ + "static/5-a7a98e89d84915e91fffc193db70b5a1.webp";